import script from "./EmployeesWithBirthdays.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeesWithBirthdays.vue?vue&type=script&setup=true&lang=js"

import "./EmployeesWithBirthdays.vue?vue&type=style&index=0&id=55216b4c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55216b4c"]])

export default __exports__